<template>
	<div class="form-root align-items-center bg-body-tertiary d-flex">
		<main class="form-signin text-center w-100 m-auto py-4 d-flex">
		<form class="w-100">
			<img class="mb-4" src="../assets/logo.png" alt="" width="101" height="41">
			<h1 class="h4 mb-4 fw-normal">Авторизація</h1>

			<div class="form-floating mb-2">
				<input
					v-model="login"
					v-on:keydown.enter="singin"
					type="login"
					class="form-control form-signin-login"
					id="floatingInput"
				>
				<label for="floatingInput">{{ capitalizeFirstLetter(accountSchema.login.title) }}</label>
			</div>
			<div class="input-group form-floating mb-3">
				<input
					v-model="password"
					v-on:keydown.enter="singin"
					:type="passwordFieldType"
					class="form-control form-signin-password" id="floatingPassword"
				
				>
				<span class="input-group-append input-group-text toggle-password-button-right"  @click="switchVisibility">
					<svg
						v-if="passwordFieldType=='password'"
						xmlns="http://www.w3.org/2000/svg"
						width="16"
						height="16"
						fill="currentColor"
						class="bi bi-eye"
						viewBox="0 0 16 16"
					>
						<path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
						<path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
					</svg>
					<svg
						v-else
						xmlns="http://www.w3.org/2000/svg"
						width="16"
						height="16" 
						fill="currentColor"
						class="bi bi-eye-slash"
						viewBox="0 0 16 16"
					>
						<path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486z"/>
						<path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829"/>
						<path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708"/>
					</svg>
				</span>
				<label for="floatingPassword">{{ capitalizeFirstLetter(accountSchema.password.title) }}</label>
			</div>

			<!-- <div class="checkbox mb-3">
				<label>
					<input v-model="remember" v-on:keydown.enter="singin" type="checkbox" value="remember-me">
					Remember me
				</label>
			</div> -->
			<p class="text-danger">
				<label>{{ response_str }}</label>
			</p>
			<button
				id="btn-signin"
				class="w-100 btn btn-lg btn-primary"
				type="button"
				@click="singin"
			>
				Продовжити
			</button>
			<p class="mt-5 mb-3 text-muted">&copy;&nbsp;ГазІнвест</p>
		</form>
		</main>
	</div>
</template>


<script>
import { readResourceItem, RESOURCE_NAMES } from '@/api/api.js'
import { useAccontStore } from '@/stores/AccountStore.js'
import { useAccounts } from '@/composables/accounts.js'
import { SHA256 } from 'crypto-js'
import { capitalizeFirstLetter } from '@/helpers.js'

export default {
	props: {
	},

	emits: {
		'signin': null,
	},

	setup() {
		//console.log('Signin setup.')
		const accountStore = useAccontStore()
		const { accountSchema } = useAccounts()

		return {
			capitalizeFirstLetter,
			accountStore,
			accountSchema,
		}
	},

	data() {
		return {
			login: "",
			password: "",
			passwordFieldType: "password",
			response_str: "",
			remember: false,
			isFetching: false,
		}
	},

	created() {
		//console.log(`signin created()`)
	},

	mounted() {
		//console.log(`signin mounted()`)
		document.title = "Авторизація"
	},

	methods: {
		async singin() {
			/*
			// Auth with hardcoded users
			const passwd = new Map([
				["artem", "artem"],
				["aleksandr", "aleksandr"],
				["vladyslav", "vladyslav"]
			])
			if (this.login != "" && this.password != "" &&
				passwd.get(this.login) == this.password) {
				this.session.start("test_token", this.login, this.password, "ГазІнвест")
				setSession(this.session)

				window.location.hash = "/stations"
			} else {
				this.password = ''
				this.response_str = `Ви не зареєстровані, або ввели невірний ${this.accountSchema.password.title}.`
			}
			*/

			const wrongCredentials = `Невірний ${this.accountSchema.login.title} або ${this.accountSchema.password.title}`
			// Check empty login
			if (this.login.length == 0 || this.password.length == 0) {
				this.response_str = 'Заповніть всі поля авторизації!'
				return
			}

			if (this.isFetching) {
				this.response_str = 'Чекайте, йде запит...'
				return
			} else {
				this.isFetching = true
				this.response_str = ''
			}

			const hashed_password = await SHA256(this.password).toString()
			//console.log("HASH: ", hashed_password);

			await readResourceItem(
				RESOURCE_NAMES.accounts,
				this.login,
				this.login,
				hashed_password,
			).then(response => {
				if (response.password === hashed_password) {
					if (response.isEnabled) {
						this.accountStore.initAccount(response)
						this.$emit('signin')
					} else {
						this.response_str = 'Даний аккаунт вимкнено. Зверніться до адміністратора організції.'
					}
				} else {
					this.response_str = wrongCredentials
				}
			}).catch((error) => {
				console.error(`Error on singin user: "${error}"`)
				switch (error.cause?.status) {
					case 401:
						this.response_str = wrongCredentials
						break
					default:
						this.response_str = "Помилка зв'язку з сервером. Спробуйте пізніше."
				}
			}).finally(() => {
				this.isFetching = false
			})
		},

		switchVisibility() {
			this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
		}
	},

}
</script>


<style scoped>
.form-root {
	height: 100%;
	width: 100%;
}

.form-signin {
	width: 100%;
	max-width: 330px;
	padding: 15px;
	margin: auto;
}

.form-signin .checkbox {
	font-weight: 400;
}

.form-signin .form-floating:focus-within {
	z-index: 2;
}

.form-signin-login {
	margin-bottom: -1px;
}

.form-signin-password {
	margin-bottom: 10px;
	border-top-left-radius: 0.5rem;
	border-bottom-left-radius: 0.5rem;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
}
.toggle-password-button-right {
	margin-bottom: 10px;
	border-top-left-radius: 0rem;
	border-bottom-left-radius: 0rem;
	border-top-right-radius: 0.5rem !important;
	border-bottom-right-radius: 0.5rem !important;
}
</style>
